export default __webpack_public_path__ + "static/media/AboutBg2.22655cd0.png";